/**
 * Module keys behind the Settings sidebar section.
 *
 * ROLE_DIRECTOR carries a blanket bypass in ModuleRoute and in NavLinks'
 * canViewModule(), which is what lets a Director open any ordinary module
 * without an explicit grant. That bypass is deliberately NOT applied to these
 * keys: Settings configures the system itself — including Set Permission,
 * where a bypass would let a Director grant themselves every other module —
 * so a Director must hold a real grant here like any other role.
 *
 * ROLE_ADMIN still bypasses everything, in the frontend and in the backend's
 * @modulePermission policy, so admins cannot lock themselves out of the very
 * screen used to repair permissions.
 *
 * Keep in sync with the Settings group in pages/SetPermission/index.jsx and
 * with the settings routes in App.jsx.
 */
export const SETTINGS_MODULE_KEYS = [
  // Settings > Tools
  'create-template',
  'workflow',
  'rate-management',
  'create-type-unit',
  'proposal-stage',
  'format-number',
  'expense-category',
  'chart-of-account',
  'master-currency',
  'sales-target',
  // Settings > Role & Permissions
  'create-role',
  'set-permission',
  // Settings > Email Settings
  'email-template',
  'email-configuration',
];

const SETTINGS_MODULE_KEY_SET = new Set(SETTINGS_MODULE_KEYS);

/** True when ROLE_DIRECTOR's blanket module bypass must not apply to moduleKey. */
export const isSettingsModule = (moduleKey) =>
  SETTINGS_MODULE_KEY_SET.has(moduleKey);
